import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Roofing Hammer",
        price: 50,
        disprice: 40,
        stock: 10,
        content: "Ensure precision and durability with our premium roofing hammer. Designed for roofers, this hammer provides the perfect balance and power for all roofing tasks.",
        description: "Our roofing hammer is engineered for accuracy and comfort, ensuring a smooth and efficient roofing process. With a durable construction and ergonomic design, it’s a must-have for any roofer.",
        category: ["Roofing Tools", "roof accessories"],
        tags: ["Hammer", "Toolkit", "Safety"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Carbon Steel" },
            { id: 2, title: "Weight", content: "16 oz" },
            { id: 3, title: "Handle", content: "Fiberglass" },
            { id: 4, title: "Finish", content: "Anti-Rust Coating" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Jane Doe",
                date: "Feb 25, 2024",
                rating: 5,
                content: "This hammer is perfect for roofing! It’s sturdy and well-balanced. Highly recommend."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "John Smith",
                date: "Feb 26, 2024",
                rating: 5,
                content: "Great hammer for roofing jobs. Comfortable to use and very durable."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Clay Tiles",
        price: 10,
        disprice: 6,
        stock: 5,
        content: "Add timeless charm to your roofing with our premium clay tiles. Known for their durability, insulation, and classic aesthetic, they’re ideal for both modern and traditional homes.",
        description: "Our high-quality clay tiles offer excellent resistance to weather and wear. With natural thermal insulation and a beautiful earthy tone, they elevate the look of any roof while ensuring lasting performance.",
        category: ["Roofing Materials", "Roof Accessories"],
        tags: ["Tiles", "Roofing", "Safety"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Clay" },
            { id: 2, title: "Dimensions", content: "10\" x 6\"" },
            { id: 3, title: "Weight", content: "2.5 lbs each" },
            { id: 4, title: "Color", content: "Terracotta" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Emily Rose",
                date: "Mar 10, 2024",
                rating: 5,
                content: "These clay tiles look stunning on my roof. Very durable and aesthetically pleasing!"
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Liam Grant",
                date: "Mar 12, 2024",
                rating: 4,
                content: "Great quality tiles, but a bit heavy. Still very satisfied with the purchase."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Ladder",
        price: 200,
        disprice: 150,
        stock: 3,
        content: "Reach new heights safely with our sturdy roofing ladder. Designed with anti-slip feet and lightweight aluminum build, it’s ideal for roofing professionals.",
        description: "This roofing ladder offers superior stability and portability. With a durable aluminum frame, slip-resistant rungs, and safety locks, it ensures you stay secure while working at elevation.",
        category: ["Roofing Tools", "Safety Gear"],
        tags: ["Ladder", "Safety", "Toolkit"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Aluminum" },
            { id: 2, title: "Height", content: "20 ft" },
            { id: 3, title: "Weight Capacity", content: "300 lbs" },
            { id: 4, title: "Features", content: "Slip-Resistant Rungs, Safety Locks" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Carlos Bennett",
                date: "Apr 5, 2024",
                rating: 5,
                content: "Lightweight yet super sturdy. Made my roofing job a lot easier and safer."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Hannah Lee",
                date: "Apr 7, 2024",
                rating: 4,
                content: "Solid ladder with great grip. Wish it folded down smaller for storage, but overall excellent."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Tile Roof",
        price: 450,
        disprice: 350,
        stock: 0,
        content: "Enhance your home's charm and protection with our classic tile roof. Known for its longevity and timeless style, it's perfect for both modern and traditional buildings.",
        description: "Our tile roof combines elegance and endurance. Made from high-quality clay, it offers excellent insulation and weather resistance while giving your home a distinct Mediterranean look.",
        category: ["Roofing Materials", "Roof Accessories"],
        tags: ["Tiles", "Roofing", "Panel"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Clay" },
            { id: 2, title: "Color Options", content: "Terracotta, Rustic Red, Sandstone" },
            { id: 3, title: "Durability", content: "Up to 50 years" },
            { id: 4, title: "Fire Resistance", content: "Class A Rated" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Emily Carson",
                date: "Mar 10, 2024",
                rating: 5,
                content: "Gorgeous and durable. My house looks fantastic and I feel confident about the roof's performance."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Robert Evans",
                date: "Mar 12, 2024",
                rating: 5,
                content: "High-quality clay tiles that really elevate curb appeal. Worth the investment."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Measuring Tape",
        price: 25,
        disprice: 18,
        stock: 10,
        content: "Accurately measure every inch with our durable and easy-to-read measuring tape. Perfect for roofing and construction tasks.",
        description: "This heavy-duty measuring tape ensures precise measurements every time. With a high-contrast scale, sturdy locking mechanism, and compact design, it's an essential tool for professionals and DIYers alike.",
        category: ["Measurement Tools", "Roofing Tools"],
        tags: ["Tape", "Toolkit", "Safety"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Length", content: "25 ft / 7.5 m" },
            { id: 2, title: "Blade Material", content: "Steel" },
            { id: 3, title: "Case", content: "Impact-Resistant ABS" },
            { id: 4, title: "Features", content: "Auto-Lock, Belt Clip, Easy-Read Scale" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Carlos Mendes",
                date: "Mar 18, 2024",
                rating: 5,
                content: "Super reliable measuring tape. Used it for roofing projects—works like a charm!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Laura Smith",
                date: "Mar 19, 2024",
                rating: 4,
                content: "Accurate and easy to handle. Great value for the price!"
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Hard Hat",
        price: 50,
        disprice: 28,
        stock: 8,
        content: "Stay protected on the job with our high-impact hard hat, built for safety and comfort in all roofing and construction environments.",
        description: "Our hard hat features a tough outer shell and adjustable suspension system to provide excellent head protection without compromising on comfort. Ideal for roofers, builders, and site workers.",
        category: ["Safety Gear", "Roofing Tools"],
        tags: ["Helmet", "Safety", "Toolkit"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Density Polyethylene (HDPE)" },
            { id: 2, title: "Adjustment", content: "Ratchet Suspension System" },
            { id: 3, title: "Standards", content: "ANSI/ISEA Z89.1-2014" },
            { id: 4, title: "Features", content: "Shock Absorption, Ventilation Slots" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Kevin Adams",
                date: "Apr 2, 2024",
                rating: 5,
                content: "Solid build and fits great. I use it on-site every day—never lets me down."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Rita Johnson",
                date: "Apr 3, 2024",
                rating: 4,
                content: "Very comfortable and protective. Good ventilation too!"
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Roofing Toolkit",
        price: 150,
        disprice: 120,
        stock: 2,
        content: "All-in-one roofing toolkit packed with essential tools for any roofing task. Durable, organized, and built for professionals.",
        description: "Our roofing toolkit includes everything you need to tackle common roofing jobs with confidence and efficiency. From hammers to utility knives and measuring tools, each item is crafted for reliability and long-lasting use.",
        category: ["roof accessories", "Roofing Tools"],
        tags: ["Toolkit", "Hammer", "Roofing"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Components", content: "12-Piece Tool Set" },
            { id: 2, title: "Case Material", content: "Reinforced Plastic" },
            { id: 3, title: "Usage", content: "General Roofing & Repairs" },
            { id: 4, title: "Warranty", content: "2 Years" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Liam Turner",
                date: "Mar 10, 2024",
                rating: 5,
                content: "Great value! All the tools I need in one place. Solid quality and well-organized."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Nina Lopez",
                date: "Mar 12, 2024",
                rating: 4,
                content: "Very handy toolkit. A few tools could be heavier duty, but overall very satisfied."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Roof-Mounted Solar Panel",
        price: 350,
        disprice: 300,
        stock: 0,
        content: "Efficient and eco-friendly roof-mounted solar panel to harness clean energy while reducing electricity bills.",
        description: "This high-performance solar panel is engineered for rooftop installations, offering maximum energy output and long-term durability. Ideal for both residential and commercial roofs, it supports sustainable living and energy independence.",
        category: ["Roof Accessories", "Roofing Materials"],
        tags: ["Panel", "Roofing", "Safety"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Output", content: "350 Watts" },
            { id: 2, title: "Material", content: "Tempered Glass & Aluminum" },
            { id: 3, title: "Dimensions", content: "65 x 39 inches" },
            { id: 4, title: "Warranty", content: "25 Years Performance Guarantee" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Olivia Chen",
                date: "Mar 18, 2024",
                rating: 5,
                content: "Excellent panel. Easy to install and I’ve already noticed a drop in my energy bill!"
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Marcus Hill",
                date: "Mar 20, 2024",
                rating: 5,
                content: "Solid build and great output. Perfect for residential solar projects."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Roof Window",
        price: 300,
        disprice: 220,
        stock: 25,
        content: "Brighten up your attic or loft with our high-quality roof window. Designed for optimal light and ventilation.",
        description: "This roof window enhances the aesthetics and functionality of any sloped roof space. Crafted with durable materials and a secure locking system, it allows natural light and fresh air to flow in while maintaining insulation and weather protection.",
        category: ["Roof Accessories", "Roofing Materials"],
        tags: ["Window", "Roofing", "Safety"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Laminated Glass & Aluminum Frame" },
            { id: 2, title: "Size", content: "30 x 40 inches" },
            { id: 3, title: "Opening Type", content: "Center Pivot" },
            { id: 4, title: "UV Protection", content: "Yes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Sophie Allen",
                date: "Apr 4, 2024",
                rating: 5,
                content: "Love how much light this brings into our attic! The build quality is excellent too."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "David Martin",
                date: "Apr 5, 2024",
                rating: 4,
                content: "Looks great and functions well. Installation took a bit longer than expected, but worth it."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Hammer Tool",
        price: 40,
        disprice: 30,
        stock: 120,
        content: "A must-have for every roofer, our hammer tool combines strength and precision for efficient roofing tasks.",
        description: "This hammer tool is designed for professionals who need reliability and power. With a balanced head and ergonomic handle, it provides the comfort and durability you need for various roofing jobs.",
        category: ["Roofing Tools", "roof accessories"],
        tags: ["Hammer", "Toolkit", "Safety"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Forged Steel" },
            { id: 2, title: "Weight", content: "20 oz" },
            { id: 3, title: "Handle", content: "Rubberized Grip" },
            { id: 4, title: "Finish", content: "Rust-Resistant Coating" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Emily Young",
                date: "Mar 15, 2024",
                rating: 5,
                content: "This hammer is perfect for all my roofing projects. Very sturdy and feels great in hand!"
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Michael Brown",
                date: "Mar 16, 2024",
                rating: 4,
                content: "Works great, but I wish the handle had a bit more cushioning for longer use."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Clay Tiles",
        price: 70,
        disprice: 55,
        stock: 200,
        content: "Durable and stylish, our clay tiles are perfect for adding a classic touch to any roofing project.",
        description: "Crafted from high-quality clay, these tiles provide exceptional durability and weather resistance. Ideal for both residential and commercial projects, they offer a traditional aesthetic with modern performance.",
        category: ["Roofing Materials", "Roof Accessories"],
        tags: ["Tiles", "Roofing", "Panel"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Clay" },
            { id: 2, title: "Size", content: "12\" x 8\"" },
            { id: 3, title: "Weight", content: "6 lbs per tile" },
            { id: 4, title: "Finish", content: "Glossy Finish for Long-Lasting Appeal" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Alice Green",
                date: "Mar 20, 2024",
                rating: 5,
                content: "These clay tiles look amazing on my roof! They add a classic and timeless look, and they’re incredibly durable."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "David White",
                date: "Mar 21, 2024",
                rating: 4,
                content: "Nice tiles with great finish, but I had to wait a little longer for delivery."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Ladder Stand",
        price: 120,
        disprice: 100,
        stock: 150,
        content: "A sturdy and reliable ladder stand designed to offer extra stability and safety during roofing work.",
        description: "Our ladder stand is engineered to support heavier loads, providing a secure platform for roofers to work with ease. It’s perfect for accessing rooftops and provides stability while handling roofing materials.",
        category: ["Roofing Tools", "Safety Gear"],
        tags: ["Ladder", "Toolkit", "Safety"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Aluminum Alloy" },
            { id: 2, title: "Height", content: "12 feet" },
            { id: 3, title: "Weight", content: "20 lbs" },
            { id: 4, title: "Capacity", content: "300 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Robert Gray",
                date: "Mar 28, 2024",
                rating: 5,
                content: "This ladder stand is a game-changer for roofers. It’s incredibly stable and comfortable to work on for extended periods."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Emma Black",
                date: "Mar 30, 2024",
                rating: 4,
                content: "Good product. It provides great support, though it could be a bit lighter for easier transport."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Tile Roofing",
        price: 250,
        disprice: 180,
        stock: 250,
        content: "High-quality tile roofing materials designed to provide exceptional durability and aesthetic appeal.",
        description: "Our tile roofing offers long-lasting protection and is perfect for homeowners looking to enhance the look of their roof. Made from premium materials, it’s available in various colors and designs to suit different architectural styles.",
        category: ["Roofing Materials", "Roof Accessories"],
        tags: ["Roofing", "Tiles", "Panel"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Ceramic & Concrete" },
            { id: 2, title: "Weight", content: "5 lbs per tile" },
            { id: 3, title: "Size", content: "12 x 12 per tile" },
            { id: 4, title: "Color Options", content: "Red, Gray, Brown, Charcoal" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Daniel White",
                date: "Apr 15, 2024",
                rating: 5,
                content: "Excellent quality tiles. They are very durable and add a great aesthetic to my house. Highly recommended!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Sophia Green",
                date: "Apr 18, 2024",
                rating: 4,
                content: "Great product. These tiles are very sturdy and offer great insulation, but they are a little heavy to handle."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Measuring Tape",
        price: 30,
        disprice: 20,
        stock: 300,
        content: "Reliable and durable measuring tape ideal for accurate roof measurements and other construction projects.",
        description: "This measuring tape is perfect for precise measurements, offering both metric and imperial units for versatility. Its robust construction ensures long-lasting performance, making it a must-have tool for professionals and DIY enthusiasts alike.",
        category: ["Measurement Tools", "Roofing Tools"],
        tags: ["Tape", "Toolkit", "Roofing"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Length", content: "25 feet" },
            { id: 2, title: "Material", content: "Steel" },
            { id: 3, title: "Width", content: "0.75 inches" },
            { id: 4, title: "Measuring Units", content: "Metric & Imperial" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Emily Adams",
                date: "Mar 10, 2024",
                rating: 5,
                content: "This measuring tape is exactly what I needed. Sturdy, easy to use, and provides accurate readings every time."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Michael Brooks",
                date: "Mar 12, 2024",
                rating: 4,
                content: "Good quality tape. It's a bit bulky for small spaces, but it works great for roofing and larger projects."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Safety Helmet",
        price: 50,
        disprice: 35,
        stock: 150,
        content: "Protect yourself with our durable safety helmet, designed for roofing and construction environments.",
        description: "This safety helmet is built for comfort and maximum protection. Equipped with a secure, adjustable fit, it meets industry safety standards, ensuring your head is protected during roofing and construction tasks.",
        category: ["Safety Gear", "Roofing Tools"],
        tags: ["Helmet", "Safety", "Toolkit"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Impact ABS Plastic" },
            { id: 2, title: "Weight", content: "450 grams" },
            { id: 3, title: "Size", content: "Universal Fit" },
            { id: 4, title: "Safety Standards", content: "ANSI Z89.1-2014" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Robert Johnson",
                date: "Mar 20, 2024",
                rating: 5,
                content: "Comfortable and light! The fit is adjustable, and it feels secure. Definitely a great purchase for any roofer."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Sarah Williams",
                date: "Mar 22, 2024",
                rating: 4,
                content: "Sturdy helmet with good ventilation. A little tight around the chin strap, but overall a solid product for roofing."
            }
        ]
    }
    
    
    
    
    
    
    
    
    
    
    
    
    
    
];

export default products;